export const presets = [
  {
    letters: {},
    activeLetters: [],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'letters-diphtong': { active: true, value: '80', tick: 11 } },
    activeLetters: ['letters-diphtong'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { shifting: { active: true, value: '65', tick: 3 } },
    activeLetters: ['shifting'],
    words: {},
    activeWords: [],
    sentences: { weight: { active: true, value: '300', tick: 3 } },
    activeSentences: ['weight'],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { trembling: { active: true, value: '65', tick: 6 } },
    activeLetters: ['trembling'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: {
      'letters-diphtong': { active: true, value: '80', tick: 11 },
      hopping: { active: true, value: '20', tick: 33 },
    },
    activeLetters: ['letters-diphtong', 'hopping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: {
      hopping: { active: true, value: '15', tick: 9 },
      shifting: { active: true, value: '80', tick: 3 },
    },
    activeLetters: ['hopping', 'shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: {
      shifting: { active: true, value: '45', tick: 3 },
      rotation: { active: true, value: '35', tick: 3 },
    },
    activeLetters: ['shifting', 'rotation'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { multiply: { active: true, value: '10', tick: 36 } },
    activeLetters: ['multiply'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { shifting: { active: true, value: '65', tick: 0 } },
    activeLetters: ['shifting'],
    words: { hopping: { active: true, value: '30', tick: 0 } },
    activeWords: ['hopping'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { multiply: { active: true, value: '20', tick: 0 } },
    activeLetters: ['multiply'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      hopping: { active: true, value: '35', tick: 2 },
      rotation: { active: true, value: '25', tick: 4 },
    },
    activeLetters: ['hopping', 'rotation'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { 'letters-backwards': { active: true, value: '50', tick: 15 } },
    activeLetters: ['letters-backwards'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { hopping: { active: true, value: '30', tick: 0 } },
    activeLetters: ['hopping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '80', tick: 3 } },
    activeLetters: ['shifting'],
    words: { tilting: { active: true, value: '20', tick: 5 } },
    activeWords: ['tilting'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { tracking: { active: true, value: '80', tick: 0 } },
    activeLetters: ['tracking'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      'letters-diphtong': { active: true, value: '80', tick: 0 },
      decrease: { active: true, value: '15', tick: 0 },
    },
    activeLetters: ['letters-diphtong', 'decrease'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '55', tick: 0 } },
    activeLetters: ['shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      tracking: { active: true, value: '-30', tick: 0 },
      hopping: { active: true, value: '20', tick: 331 },
    },
    activeLetters: ['tracking', 'hopping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
    undefined: [],
  },

  {
    letters: { shifting: { active: true, value: '80', tick: 0 } },
    activeLetters: ['shifting'],
    words: { interspace: { active: true, value: '-50', tick: 0 } },
    activeWords: ['interspace'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '50', tick: 0 } },
    activeLetters: ['shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { tracking: { active: true, value: '60', tick: 0 } },
    activeLetters: ['tracking'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '35', tick: 0 } },
    activeLetters: ['shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'free-tremble': { active: true, value: '40', tick: 0 } },
    activeLetters: ['free-tremble'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { hopping: { active: true, value: '50', tick: 0 } },
    activeLetters: ['hopping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { decrease: { active: true, value: '80', tick: 0 } },
    activeLetters: ['decrease'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '75', tick: 0 } },
    activeLetters: ['shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      tracking: { active: true, value: '-30', tick: 0 },
      shifting: { active: true, value: '65', tick: 0 },
    },
    activeLetters: ['tracking', 'shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { rotation: { active: true, value: '50', tick: 0 } },
    activeLetters: ['rotation'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {},
    activeLetters: [],
    words: { tilting: { active: true, value: '35', tick: 0 } },
    activeWords: ['tilting'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '60', tick: 0 } },
    activeLetters: ['shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'letters-diphtong': { active: true, value: '80', tick: 0 } },
    activeLetters: ['letters-diphtong'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'free-tremble': { active: true, value: '50', tick: 0 } },
    activeLetters: ['free-tremble'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      rotation: { active: true, value: '30', tick: 0 },
      'upside-down-letters': { active: true, value: '30', tick: 0 },
    },
    activeLetters: ['rotation', 'upside-down-letters'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {},
    activeLetters: [],
    words: { hopping: { active: true, value: '25', tick: 0 } },
    activeWords: ['hopping'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { decrease: { active: true, value: '25', tick: 0 } },
    activeLetters: ['decrease'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {},
    activeLetters: [],
    words: { trembling: { active: true, value: '50', tick: 0 } },
    activeWords: ['trembling'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { trembling: { active: true, value: '25', tick: 0 } },
    activeLetters: ['trembling'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'letters-swapping': { active: true, value: '50', tick: 0 } },
    activeLetters: ['letters-swapping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      rotation: { active: true, value: '50', tick: 0 },
      height: { active: true, value: '15', tick: 0 },
    },
    activeLetters: ['rotation', 'height'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { shifting: { active: true, value: '35', tick: 0 } },
    activeLetters: ['shifting'],
    words: { hopping: { active: true, value: '25', tick: 0 } },
    activeWords: ['hopping'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { tracking: { active: true, value: '50', tick: 0 } },
    activeLetters: ['tracking'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'letters-backwards': { active: true, value: '50', tick: 0 } },
    activeLetters: ['letters-backwards'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {},
    activeLetters: [],
    words: { interspace: { active: true, value: '-45', tick: 0 } },
    activeWords: ['interspace'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      'letters-diphtong': { active: true, value: '100', tick: 0 },
      shifting: { active: true, value: '75', tick: 0 },
    },
    activeLetters: ['letters-diphtong', 'shifting'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { hopping: { active: true, value: '35', tick: 0 } },
    activeLetters: ['hopping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      'upside-down-letters': { active: true, value: '30', tick: 0 },
      tracking: { active: true, value: '20', tick: 0 },
    },
    activeLetters: ['upside-down-letters', 'tracking'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      height: { active: true, value: '35', tick: 0 },
      hopping: { active: true, value: '30', tick: 0 },
    },
    activeLetters: ['height', 'hopping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { 'letters-backwards': { active: true, value: '50', tick: 0 } },
    activeLetters: ['letters-backwards'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: { rotation: { active: true, value: '40', tick: 0 } },
    activeLetters: ['rotation'],
    words: { hopping: { active: true, value: '35', tick: 0 } },
    activeWords: ['hopping'],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },

  {
    letters: {
      height: { active: true, value: '-20', tick: 0 },
      'letters-swapping': { active: true, value: '35', tick: 0 },
    },
    activeLetters: ['height', 'letters-swapping'],
    words: {},
    activeWords: [],
    sentences: {},
    activeSentences: [],
    faces: {},
    activeFaces: [],
  },
];
